// Client-side A/B experiment definitions.
//
// Variants are assigned upstream: the legacy `frontend/` app's proxy buckets the
// visitor and sets an `iq-variant-<experiment>` cookie before rewriting the request
// into this app, so a Server Component only has to read the cookie back. Bots and
// anyone without the cookie fall through to `control`.

/**
 * Experiences paywall on a partially-unlocked guide: anonymous visitors see no report
 * text at all (not even the free first report) and get a signup card instead; logged-in
 * free users keep the first report and get an upgraded paywall card.
 */
export const GUIDE_ANON_EXPERIENCE_GATE_EXPERIMENT = 'guide_anon_experience_gate_v1';

export const GUIDE_ANON_EXPERIENCE_GATE_COOKIE = `iq-variant-${GUIDE_ANON_EXPERIENCE_GATE_EXPERIMENT}`;

export type ExperienceGateVariant = 'control' | 'experiment';

export type ExperienceGateMode = 'public' | 'free';

/** Who is in the experiment on this page view, or `null` when the page is out of it. */
export type ExperienceGate = {
  variant: ExperienceGateVariant;
  gateMode: ExperienceGateMode;
};

/** Structural subset of the `cookies()` store, so this stays importable client-side. */
interface CookieReader {
  get(name: string): {value: string} | undefined;
}

/**
 * Read the visitor's bucket for the experiences paywall experiment.
 * Anything unrecognised (missing cookie, stale value, bot traffic) is treated as control.
 *
 * @example
 * const variant = getExperienceGateVariant(await cookies());
 */
export function getExperienceGateVariant(cookieStore: CookieReader): ExperienceGateVariant {
  void cookieStore;
  // Retired 2026-10-06 (experiment 70): hiding the free report cut anonymous signups
  // (1.19% -> 0.93%) with no gain in paid per visitor, so everyone gets control. Visitors
  // keep the old 90-day cookie, which is why this ignores it instead of reading it.
  return 'control';
}
